/**
 * Turkish mobile phone helpers (legacy CSMS parity).
 *
 * Invitations and OTP flows identify users by phone number, so the UI
 * normalizes any common input form (05xx…, 5xx…, 90 5xx…, spaced/dashed)
 * to E.164 (+905xxxxxxxxx) before hitting the API.
 */

/** Normalize free-form input to +905xxxxxxxxx. Returns '' when empty. */
export function normalizeTurkishPhone(value: string): string {
  const digitsOnly = (value ?? '').replace(/\D/g, '');
  if (!digitsOnly) return '';

  let local = digitsOnly;
  if (local.startsWith('90')) {
    local = local.slice(2);
  } else if (local.startsWith('0')) {
    local = local.slice(1);
  }
  local = local.slice(0, 10);
  return local ? `+90${local}` : '';
}

/** True when the value is a complete E.164 Turkish mobile number. */
export function isValidTurkishMobile(value: string): boolean {
  return /^\+905\d{9}$/.test(value.trim());
}
